import { styled, Text, css, spacing, mq } from '@thg-commerce/enterprise-theme'
import { SafeHtml, Button } from '@thg-commerce/gravity-elements'
import { Grid, GridItem } from '@thg-commerce/gravity-system'

export const Title = styled.h3`
  ${Text('large1', 'alternate')};
  padding-bottom: ${spacing(2)};
`

const TextStyles = css`
  ${Text('bodyText', 'default')};
  color: ${(props) => props.theme.colors.palette.greys.dark};
`

export const Description = styled(SafeHtml)`
  ${TextStyles};
  margin-bottom: ${spacing(4)};

  & > * {
    color: ${(props) => props.theme.colors.palette.greys.dark};
  }
`

export const StyledHeading = styled.dt`
  ${Text('bodyText', 'alternate')};
`

export const StyledText = styled.dd`
  ${TextStyles};
  margin-bottom: ${spacing(4)};
`

export const IngredientList = styled.ul`
  list-style: disc;
  margin-bottom: ${spacing(4)};
  margin-left: calc(${spacing(2)} + 2px);
`

export const IngredientItem = styled.li`
  ${TextStyles};
  margin-top: 0;
`

export const StyledButton = styled(Button)`
  text-decoration: none;
  padding: 0;

  & > span {
    text-decoration: underline;
  }
`

export const StyledGrid = styled(Grid)`
  margin-top: ${spacing(1)};
  margin-bottom: ${spacing(2)};
  margin-left: 0;
  margin-right: 0;
`

export const ImageGridItem = styled(GridItem)`
  margin-left: 0;

  ${(props) => mq(props.theme.breakpointUtils.map, 'sm')} {
    margin-right: 0;
  }

  ${(props) => mq(props.theme.breakpointUtils.map, 'md')} {
    margin-right: ${spacing(4)};
  }
`

export const MethodGridItem = styled(GridItem)`
  margin-left: 0;
  margin-right: 0;
  display: flex;
  flex-direction: row;
`

export const MethodItemNumber = styled.span`
  ${Text('bodyText', 'alternate')};
  margin-right: ${spacing(0.5)};
  margin-top: ${spacing(1)};
  color: ${(props) => props.theme.colors.palette.greys.dark};
`

export const MethodItemText = styled(SafeHtml)`
  ${TextStyles};
  display: flex;
  margin-top: 0;

  & > * {
    color: ${(props) => props.theme.colors.palette.greys.dark};
  }
`

export const NutritionalInformationTable = styled.table`
  width: 100%;
  margin-top: ${spacing(1)};
  margin-bottom: ${spacing(7)};
  table-layout: fixed;
`

export const NutritionalInformationRow = styled.tr`
  background-color: ${(props) => props.theme.colors.palette.greys.white};

  &:nth-child(even) {
    background-color: ${(props) => props.theme.colors.palette.greys.lighter};
  }
`

const TableStyles = css`
  text-align: left;
  padding: ${spacing(1)};
  border: 1px solid ${(props) => props.theme.colors.palette.greys.light};
`

export const NutritionalInformationHeader = styled.th`
  ${TableStyles};
  ${Text('bodyText', 'alternate')};
`

export const NutritionalInformationCell = styled.td`
  ${TableStyles};
  ${Text('bodyText', 'default')};
`
